import type { SessionListItem } from '../model/session.types';

export function isSessionGenerating(session: SessionListItem): boolean {
    const note = session.currentNote;
    if (!note) return false;

    const generatedNote = note?.source === 'GENERATED';
    const noGenerator = generatedNote && !note?.generator;
    const generatorInProgress =
        generatedNote && note?.generator?.status !== 'DONE' && !note?.generator?.errorType;

    return noGenerator || generatorInProgress;
}
